const config_url = document.querySelector('.server_url')?.value;

class V2Quiz {
  constructor() {
    this.currentSlide = 0;
    this.slides = document.querySelectorAll('.quiz-slide');
    this.answers = {};
    this.totalSteps = Array.from(document.querySelectorAll('.quiz-slide')).filter(slide => slide.dataset.step).length;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.loadSavedAnswers();
    this.setupModalHandlers();
  }

  setupModalHandlers() {
    // Store original body padding to prevent layout shift
    const originalPadding = window.getComputedStyle(document.body).paddingRight;
    
    const lockScroll = () => {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      document.body.classList.add('modal-open');
    };
    
    const unlockScroll = () => {
      document.body.style.paddingRight = originalPadding;
      document.body.classList.remove('modal-open');
    };

    // Open modal
    document.querySelectorAll('.help-button').forEach(button => {
      button.addEventListener('click', (e) => {
        const modalId = button.dataset.modalTarget;
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.classList.remove('tw-hidden');
          lockScroll();
          
          // Focus trap
          const focusableElements = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          const firstFocusable = focusableElements[0];
          const lastFocusable = focusableElements[focusableElements.length - 1];
          firstFocusable.focus();

          modal.addEventListener('keydown', function(e) {
            if (e.key === 'Tab') {
              if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                  e.preventDefault();
                  lastFocusable.focus();
                }
              } else {
                if (document.activeElement === lastFocusable) {
                  e.preventDefault();
                  firstFocusable.focus();
                }
              }
            }
          });
        }
      });
    });

    const closeModal = (modal) => {
      if (modal) {
        modal.classList.add('tw-hidden');
        unlockScroll();
      }
    };

    // Close modal on button click
    document.querySelectorAll('.modal-close').forEach(button => {
      button.addEventListener('click', () => {
        const modal = button.closest('.modal');
        closeModal(modal);
      });
    });

    // Close modal on outside click
    document.querySelectorAll('.modal').forEach(modal => {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          closeModal(modal);
        }
      });
    });

    // Close modal on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const modal = document.querySelector('.modal:not(.tw-hidden)');
        closeModal(modal);
      }
    });
  }

  loadSavedAnswers() {
      function getCookie(name) {
          let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
          return match ? match[2] : null;
      }

      // Check if the 'customer' cookie exists
      if (!getCookie("customer")) {
          console.log("Customer cookie not found. Skipping pre-filling of answers.");
          return;
      }

      const savedData = localStorage.getItem('cookie_form_data');
      if (savedData) {
          try {
              const parsedData = JSON.parse(savedData);
              parsedData.forEach(item => {
                  // Get the slide element
                  const slide = document.querySelector(`.quiz-slide[data-question-id="${item.name}"]`);
                  if (!slide) return;

                  // Determine if it's a multi-select question
                  const isMultiSelect = slide.querySelector('[data-multi-select="true"]');

                  // Restore answers
                  this.answers[item.name] = isMultiSelect ? item.value.split(',') : item.value;

                  if (isMultiSelect && Array.isArray(this.answers[item.name])) {
                      // Restore multi-select answers
                      this.answers[item.name].forEach(value => {
                          const option = slide.querySelector(`.option-card[data-value="${value}"]`);
                          if (option) {
                              option.classList.add('selected');
                          }
                      });
                  } else {
                      // Restore single-select answers
                      const option = slide.querySelector(`.option-card[data-value="${item.value}"]`);
                      if (option) {
                          option.classList.add('selected');
                      }

                      // Restore text input answers
                      const inputField = slide.querySelector('input, textarea');
                      if (inputField) {
                          inputField.value = item.value;
                      }
                  }

                  // Enable continue button if necessary
                  const continueButton = slide.querySelector('.continue-button');
                  if (continueButton) {
                      const hasAnswer = isMultiSelect ? this.answers[item.name].length > 0 : !!this.answers[item.name];
                      continueButton.disabled = !hasAnswer;
                      continueButton.classList.toggle('tw-opacity-50', !hasAnswer);
                      continueButton.classList.toggle('tw-cursor-not-allowed', !hasAnswer);
                      continueButton.parentElement.classList.toggle('tw-hidden', !hasAnswer);

                      // Add click handler for continue button if not already added
                      if (!continueButton.hasClickHandler) {
                        continueButton.addEventListener('click', () => {
                          if (!continueButton.disabled) {
                            this.nextSlide();
                          }
                        });
                        continueButton.hasClickHandler = true;
                      }
                  }
                  document.getElementById("customer_email").value = getCookie('customer');
                  const isValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(getCookie('customer'));
                  const submitBtn = document.querySelector('#submit_email_btn');
                  if (submitBtn) submitBtn.disabled = !isValid;
                  
              });
          } catch (e) {
              console.error('Error loading saved answers:', e);
          }
      }
  }

  updateProgressBar() {
    // Progress bar width is now handled by CSS custom properties
  }

  dataLayer(step, question, response) {
    let data = {
      event: 'style_quiz_step_' + step
    };
    if (typeof(question) !== 'undefined' && question) {
      data['quiz_step_name'] = question;
    }
    const type = typeof(response);
    if (type !== 'undefined' && response) {
      if (type !== 'string') {
        response = response.join('/');
      }
      data['quiz_response'] = response;
    }

    //console.log(data);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  setupEventListeners() {
    // Option selection using event delegation
    const quizSlides = document.querySelector('.quiz-slides');
    
    // Handle clicks
    quizSlides.addEventListener('click', (e) => {
      const card = e.target.closest('.option-card');
      if (!card) return;
      
      const currentSlide = card.closest('.quiz-slide.active');
      if (!currentSlide) return;
      
      const questionId = currentSlide.dataset.questionId;
      const optionsContainer = card.closest('[data-multi-select]');
      const isMultiSelect = optionsContainer && optionsContainer.dataset.multiSelect === 'true';
      let response = '';
      
      if (isMultiSelect) {
        // Toggle selection on clicked card
        card.classList.toggle('selected');
        
        // Get all selected values
        const selectedCards = optionsContainer.querySelectorAll('.option-card.selected');
        const selectedValues = Array.from(selectedCards).map(card => card.dataset.value);

        response = Array.from(selectedCards).map(card => card.querySelector('.card-option-label') ? card.querySelector('.card-option-label').textContent.trim() : card.textContent.trim());
        
        // Store answers as array for multi-select
        this.answers[questionId] = selectedValues;
        
        // Update continue button state
        const continueButton = currentSlide.querySelector('.continue-button');
        if (continueButton) {
          continueButton.disabled = selectedValues.length === 0;
          continueButton.classList.toggle('tw-opacity-50', selectedValues.length === 0);
          continueButton.classList.toggle('tw-cursor-not-allowed', selectedValues.length === 0);
          
          // Add click handler for continue button if not already added
          if (!continueButton.hasClickHandler) {
            continueButton.addEventListener('click', () => {
              if (!continueButton.disabled) {
                this.nextSlide();
              }
            });
            continueButton.hasClickHandler = true;
          }
        }
      } else {
        // Single select behavior
        currentSlide.querySelectorAll('.option-card').forEach(c => {
          c.classList.remove('selected');
        });
        
        card.classList.add('selected');
        this.answers[questionId] = card.dataset.value;

        response = (card.querySelector('.card-option-label') ? card.querySelector('.card-option-label').textContent : card.textContent).trim();
        
        // Auto advance for single select
        setTimeout(() => {
          this.nextSlide();
        }, 300);
      }

      // Data layer
      const question = currentSlide.querySelector('h2').textContent.trim();
      const step = currentSlide.dataset.step;
      this.dataLayer(step, question, response);
    });

    // Handle keyboard navigation
    quizSlides.addEventListener('keydown', (e) => {
      const card = e.target.closest('.option-card');
      const continueButton = e.target.closest('.continue-button');
      const backButton = e.target.closest('.back-button');
      
      if (!card && !continueButton && !backButton) return;
      
      const currentSlide = (card || continueButton).closest('.quiz-slide.active');
      if (!currentSlide) return;

      // Enter or Space to select
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (card) {
          card.click();
          // Update ARIA state after selection
          if (isMultiSelect) {
            const isSelected = card.classList.contains('selected');
            card.setAttribute('aria-checked', isSelected);
            // If at least one option is selected, make continue button focusable
            const selectedCards = currentSlide.querySelectorAll('.option-card.selected');
            const continueBtn = currentSlide.querySelector('.continue-button');
            if (continueBtn) {
              if (selectedCards.length > 0) {
                continueBtn.focus();
              }
            }
          } else {
            card.setAttribute('aria-pressed', 'true');
          }
        } else if (continueButton && !continueButton.disabled) {
          continueButton.click();
        }
      }
      
      // Arrow key navigation between options
      if (card) {
        const optionsContainer = card.closest('[data-multi-select]') || card.parentElement;
        const options = Array.from(optionsContainer.querySelectorAll('.option-card'));
        const currentIndex = options.indexOf(card);
        
        let nextCard;
        
        switch (e.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            e.preventDefault();
            nextCard = options[currentIndex + 1] || options[0];
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            e.preventDefault();
            nextCard = options[currentIndex - 1] || options[options.length - 1];
            break;
          case 'Tab':
            // If it's a multi-select and there are selections, allow tabbing to continue button
            const isMultiSelect = card.closest('[data-multi-select="true"]');
            const continueBtn = currentSlide.querySelector('.continue-button');
            if (isMultiSelect && continueBtn && !continueBtn.disabled) {
              if (!e.shiftKey && currentIndex === options.length - 1) {
                e.preventDefault();
                continueBtn.focus();
              }
            }
            break;
        }
        
        if (nextCard) {
          nextCard.focus();
        }
      }
    });

    // Make option cards focusable and add ARIA attributes
    const setupOptionCards = () => {
      const activeSlide = document.querySelector('.quiz-slide.active');
      if (!activeSlide) return;
      
      const isMultiSelect = activeSlide.querySelector('[data-multi-select="true"]');
      const stepNumber = activeSlide.dataset.step;
      
      // Setup progress indicator
      if (stepNumber) {
        const progressBar = activeSlide.querySelector('.progress-bar');
        if (progressBar) {
          progressBar.setAttribute('role', 'progressbar');
          progressBar.setAttribute('aria-valuemin', '0');
          progressBar.setAttribute('aria-valuemax', '100');
          progressBar.setAttribute('aria-valuenow', Math.round((stepNumber / 12) * 100));
          progressBar.setAttribute('aria-label', `Progress: Step ${stepNumber} of 12`);
        }
      }

      // Setup back button
      const backButton = activeSlide.querySelector('.back-button');
      if (backButton) {
        backButton.setAttribute('tabindex', '0');
        backButton.setAttribute('role', 'button');
        backButton.setAttribute('aria-label', 'Go back to previous question');
      }
      
      activeSlide.querySelectorAll('.option-card').forEach(card => {
        card.setAttribute('tabindex', '0');
        card.setAttribute('role', isMultiSelect ? 'checkbox' : 'button');
        card.setAttribute(isMultiSelect ? 'aria-checked' : 'aria-pressed', card.classList.contains('selected'));
        
        // Update ARIA label to include the option text and whether it's selected
        const optionText = card.querySelector('p')?.textContent || '';
        const selectionState = card.classList.contains('selected') ? 'Selected: ' : '';
        card.setAttribute('aria-label', `${selectionState}${optionText}`);
      });

      // Make continue button focusable in multi-select slides
      const continueButton = activeSlide.querySelector('.continue-button');
      if (continueButton) {
        continueButton.setAttribute('tabindex', '0');
        continueButton.setAttribute('role', 'button');
        continueButton.setAttribute('aria-label', 'Continue to next question');
      }

      // Announce slide change to screen readers
      const question = activeSlide.querySelector('h2')?.textContent || '';
      if (question) {
        const announcement = document.createElement('div');
        announcement.setAttribute('role', 'status');
        announcement.setAttribute('aria-live', 'polite');
        announcement.className = 'tw-sr-only';
        announcement.textContent = `Question: ${question}`;
        activeSlide.appendChild(announcement);
        
        // Remove the announcement after it's been read
        setTimeout(() => {
          announcement.remove();
        }, 1000);
      }
    };

    // Setup initial slide
    setupOptionCards();

    // Setup cards when slide changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (mutation.target.classList.contains('active')) {
            setupOptionCards();
          }
        }
      });
    });

    document.querySelectorAll('.quiz-slide').forEach(slide => {
      observer.observe(slide, { attributes: true });
    });

    // Email input validation
    const emailInput = document.querySelector('#customer_email');
    if (emailInput) {
      emailInput.addEventListener('input', (e) => {
        const email = e.target.value;
        const isValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
        const submitBtn = document.querySelector('#submit_email_btn');
        if (submitBtn) submitBtn.disabled = !isValid;
      });
    }


    function showPopupToCustomerdata(email, cfn) {
    	let is_popup_show = document.getElementById("show_popup_to_customer");
    	if (!is_popup_show) {
    	  is_popup_show = document.createElement("input");
    	  is_popup_show.type = "hidden";
    	  is_popup_show.id = "show_popup_to_customer";
    	  is_popup_show.className = "show-popup-to-customer"; // Add your custom class
    	  document.body.appendChild(is_popup_show); // Append it to the body or a specific container
    	}
    	is_popup_show.value = "true";

    	event.preventDefault();
    	if (!document.getElementById("confirmationPopup")) {
    		const modalHtml = `
    			<div id="confirmationPopup" style="display: none; position: fixed; z-index: 1000; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgba(0,0,0,0.4);">
    			<div id="popupContent" style="background-color: white; margin: 15% auto; padding: 20px; border: 1px solid #888; width: 80%; max-width: 400px; text-align: center; border-radius: 8px;">
    				<p>Active members can modify their style preferences only through the member portal. Please create an account or proceed to the plan pricing page.</p>
    				<button id="viewPlan" style="margin-right: 10px; padding: 10px; background-color: black; color: white; border: none; border-radius: 5px;width:100%!important;margin-bottom:10px">View Plans</button>
    				<button id="createAccount" style="padding: 10px; background-color: black; color: white; border: none; border-radius: 5px;width:100%!important">Create Account</button>
    			</div>
    			</div>`;
    		document.body.insertAdjacentHTML("beforeend", modalHtml);
    	}
    	const popup = document.getElementById("confirmationPopup");
    	popup.style.display = "block";

    	popup.addEventListener('click', function (e) {
    		if (e.target === popup) {
    			popup.style.display = "none";
    		}
    	});

    	document.getElementById("viewPlan").onclick = function () {
    //		localStorage.setItem('odoo_quiz_completed', 'true');
    //		localStorage.setItem('current_template_version', 'v1');
    //		localStorage.setItem('login_return_to', '/pages/luxe');
    //		let form_data = JSON.parse(localStorage.getItem("quiz_form_data"));
    //        console.log(form_data) ;
    //        setQuizDataInOdoo(form_data)
    		location.href = "/pages/plans-and-pricing";
    	};
    	document.getElementById("createAccount").onclick = function () {
    		localStorage.setItem('login_return_to', '/pages/plans-and-pricing');
    		localStorage.removeItem("accountCreateMessage");
    		localStorage.removeItem("messageTimestamp");
    //		location.href = `/pages/create-account?em=${btoa(email)}`
            let url = `/pages/create-account?em=${btoa(email)}`;

            if (cfn) {
                url += `&cfn=${btoa(cfn)}`;
            }

            location.href = url;
    	};
    }

    function showPopupToCustomerdataLogin() {
    	let is_popup_show = document.getElementById("show_popup_to_customer");
    	if (!is_popup_show) {
    	  is_popup_show = document.createElement("input");
    	  is_popup_show.type = "hidden";
    	  is_popup_show.id = "show_popup_to_customer";
    	  is_popup_show.className = "show-popup-to-customer"; // Add your custom class
    	  document.body.appendChild(is_popup_show); // Append it to the body or a specific container
    	}
    	is_popup_show.value = "true";

    	event.preventDefault();
    	if (!document.getElementById("confirmationPopup")) {
    		const modalHtml = `
    			<div id="confirmationPopup" style="display: none; position: fixed; z-index: 1000; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgba(0,0,0,0.4);">
    			<div id="popupContent" style="background-color: white; margin: 15% auto; padding: 20px; border: 1px solid #888; width: 80%; max-width: 400px; text-align: center; border-radius: 8px;">
    				<p>Active members can modify their style preferences only through the member portal. Please visit the member portal or proceed to the plan pricing page.</p>
    				<button id="viewPlan" style="margin-right: 10px; padding: 10px; background-color: black; color: white; border: none; border-radius: 5px;width:100%!important;margin-bottom:10px">View Plans</button>
    				<button id="viewDashboard" style="padding: 10px; background-color: black; color: white; border: none; border-radius: 5px;width:100%!important">View Dashboard</button>
    			</div>
    			</div>`;
    		document.body.insertAdjacentHTML("beforeend", modalHtml);
    	}
    	const popup = document.getElementById("confirmationPopup");
    	popup.style.display = "block";

    	popup.addEventListener('click', function (e) {
    		if (e.target === popup) {
    			popup.style.display = "none";
    		}
    	});

    	document.getElementById("viewPlan").onclick = function () {
    		location.href = "/pages/plans-and-pricing";
    	};
    	document.getElementById("viewDashboard").onclick = function () {
    		location.href = "/account?view=quizstyle";
    	};
    }


    // the below code is handling the submit of the captcha form

            let captcha_password = document.getElementById("captcha_password");

        if (captcha_password) {
            captcha_password.addEventListener("keypress", function (event) {
              let e_code = event.keyCode || event.which;
              if (event.key === "Enter" || e_code == 13) {
                  event.preventDefault();
                  document.getElementById("captcha_protected_sbm_btn").click();
              }
          });
          captcha_password.addEventListener("input", function (event) {
            const inputValue = event.target.value;
            console.log("Captcha Input Value:", inputValue); // Debugging
            // Store the value explicitly (e.g., in a global object or localStorage)
            captcha_password.value = inputValue;
          });
        } else {
          console.error("Captcha input field not found!");
        }

    $('#captcha_protected_sbm_btn').on('click', function (event) {

      const captchaEmail = document.getElementById("captcha_email").value;
      const captchaPassword = document.getElementById("captcha_password").value;

      document.getElementById("customer_email").value = captchaEmail;
      document.getElementById("customer_password").value = captchaPassword;

      console.log("Submitting form with:");
      console.log("customer[email]:", captchaEmail);
      console.log("customer[password]:", captchaPassword);
      deleteCookie("odoo_customer_id");

	  $('#captcha_protected_sbm_btn').prepend('<i class="fa fa-spinner fa-spin"></i>');
	  console.log("captcha protected button clicked")
	  localStorage.setItem('odoo_quiz_completed', 'true');
	  localStorage.setItem('current_template_version', 'v1');
	  localStorage.setItem('login_return_to', '/pages/plans-and-pricing')
      $('#captcha_protected_sbm_btn').prepend('<i class="fa fa-spinner fa-spin"></i>');
      event.preventDefault();
      let captcha_password = document.getElementById("captcha_password");
      if (!captcha_password.value) {
        alert("Password is required to proceed!");
        $('#captcha_protected_sbm_btn i.fa-spinner').remove();
      }
      else{
      let showPopupToCustomer = document.getElementById("show_popup_to_customer");
        if (showPopupToCustomer && showPopupToCustomer.value === "true") {
          event.preventDefault();
          if (!document.getElementById("confirmationPopup")) {
            const modalHtml = `
              <div id="confirmationPopup" style="display: none; position: fixed; z-index: 1000; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgba(0,0,0,0.4);">
                <div id="popupContent" style="background-color: white; margin: 15% auto; padding: 20px; border: 1px solid #888; width: 80%; max-width: 400px; text-align: center; border-radius: 8px;">
                  <p>Active members can modify their style preferences only through the member portal. Please visit the member portal or proceed to the plan pricing page.</p>
                  <button id="popupOk" style="margin-right: 10px; padding: 10px; background-color: black; color: white; border: none; border-radius: 5px;width:100%!important;margin-bottom:10px">View Plans</button>
                  <button id="popupCancel" style="padding: 10px; background-color: black; color: white; border: none; border-radius: 5px;width:100%!important">View Dashboard</button>
                </div>
              </div>`;
            document.body.insertAdjacentHTML("beforeend", modalHtml);
          }
          const popup = document.getElementById("confirmationPopup");
          popup.style.display = "block";

          popup.addEventListener('click', function (e) {
            if (e.target === popup) {
              popup.style.display = "none";
            }
          });

          document.getElementById("popupOk").onclick = function () {
  //		  localStorage.setItem('odoo_quiz_completed', 'true');
  //		  localStorage.setItem('current_template_version', 'v1');
            localStorage.setItem('login_return_to', '/pages/plans-and-pricing');
            document.getElementById('captcha_form').submit();
          };
          document.getElementById("popupCancel").onclick = function () {
            localStorage.setItem('login_return_to', '/account?view=quizstyle');
            var captcha_form = document.getElementById("captcha_form");
            captcha_form.action = '/account/login?return_to=/account?view=quizstyle'
            captcha_form.submit();
          };
        } else {
          localStorage.setItem('login_return_to', '/pages/plans-and-pricing');
          document.getElementById('captcha_form').submit();
        }
      }
    });

 //    $('#submit_email_btn').on('click',async function () {
 //        console.log("inside the call for the check_customer");
	// 	let email = $('#customer_email').val();
	// 	if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))) {
	// 		alert("Please enter a valid email address.");
	// 	} else {
	// 		let form_data = localStorage.getItem("quiz_form_data");
	// 		// localStorage.setItem("quiz_form_data", JSON.stringify(form_data));
	// 		 // var checkEmail = await emailValidation(email);
 //          let checkEmail = {"status": "valid"};
 //          console.log(checkEmail+"ChcekEmail uavsjk");
 //          if(checkEmail.status=="valid" || checkEmail.status=="catch-all" || checkEmail.status=="abuse" || checkEmail.status=="unknown" || checkEmail.sub_status=="antispam_system" || checkEmail.sub_status=="exception_occurred" || checkEmail.sub_status=="failed_smtp_connection" || checkEmail.sub_status=="forcible_disconnect" || checkEmail.sub_status=="greylisted" || checkEmail.sub_status=="mail_server_did_not_respond" || checkEmail.sub_status=="mail_server_temporary_error" || checkEmail.sub_status=="timeout_exceeded" || checkEmail.sub_status=="Does_not_accept_mail" || checkEmail.sub_status == "Failed_syntax_check" || checkEmail.sub_status =="Possible_typo" || checkEmail.sub_status == "Mailbox_not_found" || checkEmail.sub_status == "No_dns_entries" || checkEmail.sub_status == "Unroutable_ip_address" || checkEmail.sub_status == "Mailbox_quota_exceeded" || checkEmail.status == "do_not_mail"){
	// 		checkCustomerStatus1(form_data);
 //          }else{
 //            $('.error_message').css('color', 'red');
 //            $('.error_message').css('display', 'block').text('Please enter a valid email.');
	// 		setTimeout(function () {
	// 			$('.error_message').css('display', 'none');
	// 		}, 2000);
 //          }
	// 		// checkCustomerStatus();
	// 	}
	// });

    $('#submit_email_btn').on('click', function () {
		$(this).css({
            'background-color': '#d5d5d5',
            'color': '#666',
            'cursor': 'not-allowed'
        }).prop('disabled', true);
		let email = $('#customer_email').val();
		if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))) {
			enableSubmitButton();
			alert("Please enter a valid email address.");
		} else {
            let form_data = localStorage.getItem("quiz_form_data");
			// let form_data = $("#custom_from_quiz").serializeArray();
			// localStorage.setItem("quiz_form_data", JSON.stringify(form_data));
			deleteCookie("odoo_customer_id");
			checkCustomerStatus1(form_data);
			document.cookie = `customer=${email}; path=/; max-age=31536000000; SameSite=Lax`; // max-age for 100 years // Added custom
			// checkCustomerStatus();
		}
	})

    $('#customer_email').on('keypress', function (e) {
        if (e.which === 13) {
            $('#submit_email_btn').trigger('click');
        }
    });


    function getCookie(name) {
        console.log("in the function");
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
        return null;
    }
    function deleteCookie(name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    function checkCustomerStatus1(form_data) {
		var customerEmail = false
		if(document.cookie.match('(^| )customer=([^;]+)')){
          customerEmail = getCookie('customer');
        }

      // currently changed
        form_data = JSON.parse(form_data);

        form_data.push({
            name: "old_email",
            value: customerEmail || ""
        });
    var email = $("#customer_email").val();
    if (email !== "") {
        $("#submit_email_btn").prop("disabled", true).text('Wait...');

        $("#customer_email")
			.prop("disabled", true)
			.css({
				"background-color": "grey",
				"cursor": "not-allowed",
			});
        // setTimeout(function () {
        //     $("#customer_email")
        //     .prop("disabled", false)
        //     .val("Continue with Email")
        //     .css({
        //         "background-color": "",
        //         "cursor": "",
        //     });
        // }, 10000);

      let url = config_url + "/check_customer1";
      $.ajax({
        url: url,
        type: "post",
        crossDomain: true,
        data: form_data,
        success: function (msg) {
            $("#submit_email_btn").prop("disabled", false).text('Continue With Email');

			let parsedMsg = false
			if(msg.length > 0){
    			if (typeof msg !== "string") {
                    parsedMsg = JSON.parse(msg);
                } else if (typeof msg == "string" && msg.trim().startsWith("{")) {
                    console.log("type of msg is string");
                    try {
                        parsedMsg = JSON.parse(msg);
                    } catch (error) {
                        console.error("Error parsing msg:", error);
                        parsedMsg = null; // Prevents errors if parsing fails
                    }
                }
            }

            let cfn = false

			console.log("msg", msg)
			if(msg && parsedMsg && parsedMsg.cookie_new_customer_id){
				console.log("entered else if");
				function setCookie(name, value, days) {
                  let expires = "";
                  if (days) {
                    let date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Set expiration time in milliseconds
                    expires = "; expires=" + date.toUTCString();
                  }
                  document.cookie = name + "=" + (value || "") + expires + "; path=/"; // Set the cookie
                }

				setCookie('odoo_customer_id', parsedMsg.cookie_new_customer_id, 100 * 365);
				if(parsedMsg.true_with_order){
				    console.log("setting the msg to true_with_order");
				    if(parsedMsg.customer_full_name){
				        cfn = parsedMsg.customer_full_name;
				    }
				    msg = "true_with_order"
				}
			}
          // CASE 1: Existing user (msg === "true")
          if (msg === "true") {


			let is_popup_show = document.getElementById("show_popup_to_customer");
			if (!is_popup_show) {
			is_popup_show = document.createElement("input");
			is_popup_show.type = "hidden";
			is_popup_show.id = "show_popup_to_customer";
			is_popup_show.className = "show-popup-to-customer"; // Add your custom class
			document.body.appendChild(is_popup_show); // Append it to the body or a specific container
			}
			is_popup_show.value = "true";

            document.getElementById("main-quiz-form").style.display = "none";
            document.getElementById("captcha_form").style.display = "block";
            document.getElementById("main_template_starting_heading").style.display = "none";
            document.getElementById("p_for_step_line").style.display = "none";
            document.getElementById("captcha_email").value = email;
            document.getElementById("captcha_email").disabled = true;
            document.getElementById("captcha_customer_email").value = email;
            document.getElementById("captcha_password").value = "";
            document.getElementById("customer_password").value = "";
          }
		  else if (msg === "true_with_order"){
				showPopupToCustomerdata(email, cfn);
		  }
          // CASE 2: New user => We have a new password in `msg`
          else {
//            const generatedPassword = msg.trim();
            console.log("email to set in the new form", email)
//            document.getElementById("captcha_email").value = email;
//            document.getElementById("captcha_customer_email").value = email;
//            document.getElementById("captcha_password").value = generatedPassword;
//            document.getElementById("customer_password").value = generatedPassword;

            document.getElementById("captcha_form").style.display = "none";

            $.ajax({
              type: "POST",
              url: "/cart/clear.js",
              data: "",
              dataType: "json",
              success: function () {
                Shopify.clear();
              },
              error: function (XMLHttpRequest, textStatus) {
                console.warn("Could not clear cart:", textStatus);
              },
            });
//            This variable added to set VWO/Klaviyo/campaign/selling plan
            localStorage.setItem('new_customer_logged_in', 'true')
			localStorage.setItem('odoo_logged_in', 'true');
			localStorage.setItem('odoo_quiz_complete', 'true');
			localStorage.setItem('style_profile_quiz', 'true');
			localStorage.setItem("set_style_quiz_dress_for_work",1) ;
			location.href = "/pages/plans-and-pricing";
			$(".ajax-loader").css("display", "none");
          }
        },
        error: function (xhr, status, errorThrown) {
          console.error("Error calling /check_customer1:", status, errorThrown);
		  enableSubmitButton()
          // $("#customer_email").val("Continue with Email");
		  	localStorage.setItem('odoo_logged_in', 'true');
			localStorage.setItem('odoo_quiz_complete', 'true');
			localStorage.setItem('style_profile_quiz', 'true');
			localStorage.setItem("set_style_quiz_dress_for_work",1) ;
			location.href = "/pages/plans-and-pricing";
          $(".ajax-loader").css("display", "none");
        },
        complete: function () {
          // Reset the flag and re-enable the button
          // isAjaxInProgress = false;
          $("#customer_email").prop("disabled", false);
        },
      });
    } else {
      $(".ajax-loader").css("display", "none");
      $(".error_message").css("display", "block").text("Please enter email id");
      setTimeout(function () {
        $(".error_message").css("display", "none");
      }, 2000);
    }
  }

  }

  async checkCustomerStatus(email) {
    try {
      const response = await fetch(`${config_url}/check_customer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email })
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error checking customer status:', error);
      throw error;
    }
  }

  showSuccessSlide() {
    const currentSlide = document.querySelector('.quiz-slide.active');
    const successSlide = document.querySelector('.quiz-slide[data-slide*="success"]');

    if (currentSlide && successSlide) {
      currentSlide.classList.remove('active');
      currentSlide.classList.add('hidden');
      successSlide.classList.remove('hidden');
      successSlide.classList.add('active');

      // Initialize confetti
      const jsConfetti = new JSConfetti();
      jsConfetti.addConfetti({
        confettiColors: [
          '#000000', // Black
          '#FFFFFF', // White
          '#808080', // Gray
          '#C0C0C0'  // Silver
        ],
        confettiRadius: 6,
        confettiNumber: 200
      });
    }
  }

  storeFilteredFormDataCookie(formData) {
        console.log("inside storing form data function");
        const filteredData = formData.filter(item =>
            item.name === "email" || !isNaN(Number(item.name))
        );

        localStorage.setItem("cookie_form_data", JSON.stringify(filteredData));
    }

  async submitQuizData() {
    try {
      console.log("inside submit form data");
      // const formData = Object.entries(this.answers).map(([name, value]) => {
      //   // If value is an array (from multi-select), join with commas
      //   const processedValue = Array.isArray(value) ? value.join(',') : value;
      //   return {
      //     name,
      //     value: processedValue
      //   };
      // });

      // custom added temporarily as the questions are commented

      const formData = Object.entries(this.answers)
        .filter(([name, value]) => name !== '' && value !== undefined) // Remove empty string keys and undefined values
        .map(([name, value]) => ({
          name,
          value: Array.isArray(value) ? value.join(',') : value
        }));

      // Function to update formData by replacing existing key or adding a new one
      const updateFormData = (key, value) => {
        // Remove existing entry for the key
        const index = formData.findIndex(item => item.name === key);
        if (index !== -1) {
          formData.splice(index, 1); // Remove old entry
        }
        // Add new entry if value is not empty
        if (value !== undefined) {
          formData.push({ name: key, value });
        }
      };

      // **Keys that need to be updated**
      const keysToRemove = [
        'business_name',
        'template_version',
        'server_url',
        'customer_id',
        'email',
        'additional_question'
      ];

      // **Remove these keys if they already exist in formData**
      keysToRemove.forEach(key => {
        const index = formData.findIndex(item => item.name === key);
        if (index !== -1) {
          formData.splice(index, 1);
        }
      });

        let updatedFormData = [];
        formData.forEach(item => {
            let name = item.name;
            let values = item.value.split(",");
            values.forEach(value => {
                updatedFormData.push({ name: name, value: value.trim() });
            });
        });

        formData.length = 0;
        formData.push(...updatedFormData);

        console.log("Updated Form Data: ", formData);

      // **Manually add/update input fields**
      const businessNameInput = document.querySelector('input[name="business_name"]');
      if (businessNameInput) {
        updateFormData('business_name', businessNameInput.value);
      }

      const templateVersionInput = document.querySelector('input[name="template_version"]');
      if (templateVersionInput) {
        updateFormData('template_version', templateVersionInput.value);
      }

      const serverUrlInput = document.querySelector('input[name="server_url"]');
      if (serverUrlInput) {
        updateFormData('server_url', serverUrlInput.value);
      }

      const customerIdInput = document.getElementById('quiz_customer_id');
      if (customerIdInput) {
        updateFormData('customer_id', customerIdInput.value);
      }

      const customerEmailInput = document.getElementById('customer_email');
      if (customerEmailInput) {
        updateFormData('email', customerEmailInput.value);
      }

      // **Ensure "additional_question" is always in formData with a null value**
      updateFormData('additional_question', null);

      // document.querySelectorAll('input[type="hidden"]').forEach(input => {
      // formData.push({
      //     name: input.name,
      //     value: input.value
      //   });
      // });
      // console.log("Filtered formData:", formData);


      localStorage.setItem('quiz_form_data', JSON.stringify(formData));
      console.log("trying to set the filtered form data cookie");
      this.storeFilteredFormDataCookie(formData);

      // Step 10
      this.dataLayer(10, 'Email Collection');

      // const response = await fetch(`${config_url}/set_customer_quiz_data`, {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify(formData)
      // });

      // if (response.ok) {
      //   localStorage.setItem('odoo_quiz_complete', 'true');
      //   localStorage.setItem('style_profile_quiz', 'true');
      //   window.location.href = '/pages/plans-and-pricing';
      // } else {
      //   throw new Error('Failed to submit quiz data');
      // }
    } catch (error) {
      console.error('Error submitting quiz data:', error);
      throw error;
    }
  }

  nextSlide() {
    const currentSlide = document.querySelector('.quiz-slide.active');
    const nextSlide = currentSlide.nextElementSibling;
    
    if (nextSlide && nextSlide.classList.contains('quiz-slide')) {
      currentSlide.classList.remove('active');
      currentSlide.classList.add('hidden');
      nextSlide.classList.remove('hidden');
      nextSlide.classList.add('active');
      
      // Update progress bar
      this.updateProgressBar();

      // Focus management
      const firstFocusable = nextSlide.querySelector('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), .option-card[tabindex="0"]');
      if (firstFocusable) {
        setTimeout(() => {
          firstFocusable.focus();
        }, 100);
      }
    }
  }

  previousSlide() {
    const currentSlide = document.querySelector('.quiz-slide.active');
    const prevSlide = currentSlide.previousElementSibling;
    
    if (prevSlide && prevSlide.classList.contains('quiz-slide')) {
      currentSlide.classList.remove('active');
      currentSlide.classList.add('hidden');
      prevSlide.classList.remove('hidden');
      prevSlide.classList.add('active');
      
      // Update progress bar
      this.updateProgressBar();

      // Focus management
      const firstFocusable = prevSlide.querySelector('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), .option-card[tabindex="0"]');
      if (firstFocusable) {
        setTimeout(() => {
          firstFocusable.focus();
        }, 100);
      }
    }
  }
}

// Initialize quiz
window.addEventListener('DOMContentLoaded', () => {
  window.v2Quiz = new V2Quiz();
});

// Global navigation functions
function nextSlide() {
  window.v2Quiz.nextSlide();
}

function previousSlide() {
  window.v2Quiz.previousSlide();
}

// Handle browser back/forward buttons
if (window.history && window.history.pushState) {
  window.addEventListener('popstate', (event) => {
    const currentPath = window.location.pathname;
    const step = parseInt(currentPath.split('/').pop()) || 1;
    
    const currentSlide = document.querySelector('.quiz-slide.active');
    const targetSlide = document.querySelector(`[data-step="${step}"]`);
    
    if (targetSlide) {
      currentSlide.classList.remove('active');
      currentSlide.classList.add('hidden');
      targetSlide.classList.remove('hidden');
      targetSlide.classList.add('active');
      
      // Update progress bar
      window.v2Quiz.updateProgressBar();
    }
  });
}
